import { BeamInterface, SectionInterface, StoreWallInterface } from "../../types/store";
import { useStoreSystem } from "../../useStoreSystem";

export const updateBeams = (rack: StoreWallInterface) => {
    const sections = rack.sections;
    const beams: BeamInterface[] = [];
    const beamsNormalize: Record<string, BeamInterface> = {};

    const groupByIndentSections = sections.reduce(
        (acc: { length: number; sections: SectionInterface[] }[], section, index) => {
            if (section.isIndent) {
                acc.push({
                    length: 0,
                    sections: [],
                });
                return acc;
            }

            if (index === 0) {
                acc.push({
                    length: section.width,
                    sections: [section],
                });
                return acc;
            }

            acc[acc.length - 1].sections.push(section);
            acc[acc.length - 1].length += section.width;

            return acc;
        },
        []
    );

    const groupByLength = (amount: number, availableValues: number[]) => {
        const collect = (amount: number, widths: number[]): Record<string, any> | undefined => {
            if (amount === 0) return {};

            const currentNominal = widths[0];
            const widthsNeeded = Math.floor(amount / currentNominal);

            for (let i = widthsNeeded; i >= 0; i--) {
                const result: Record<string, any> | undefined = collect(amount - i * currentNominal, widths.slice(1));

                if (result) {
                    return i ? { [currentNominal]: i, ...result } : result;
                }
            }
        };

        const widths = availableValues.map(Number).sort((a, b) => b - a);

        return collect(amount, widths) ?? {};
    };

    const availableSizes: number[] = [];
    const models: Record<string, string> = {};
    const modelIds: Record<string, string> = {};

    useStoreSystem
        .getState()
        .parts?.filter((part) => part.NAME.toLowerCase().includes("горизонталь"))
        .forEach((part) => {
            if (part.NAME.includes("512")) {
                models["480"] = part.PROPERTIES.FILE_3D;
                modelIds["480"] = part.ID;
                availableSizes.push(480);
            }
            if (part.NAME.includes("632")) {
                models["600"] = part.PROPERTIES.FILE_3D;
                modelIds["600"] = part.ID;
                availableSizes.push(600);
            }
            if (part.NAME.includes("832")) {
                models["800"] = part.PROPERTIES.FILE_3D;
                modelIds["800"] = part.ID;
                availableSizes.push(800);
            }
            if (part.NAME.includes("1232")) {
                models["1200"] = part.PROPERTIES.FILE_3D;
                modelIds["1200"] = part.ID;
                availableSizes.push(1200);
            }
        });

    groupByIndentSections
        .filter((group) => group.length !== 0)
        .forEach((group) => {
            let widthOffset = 0;
            const groupedBeams = groupByLength(group.length, availableSizes);
            Object.keys(groupedBeams).forEach((beam) => {
                new Array(groupedBeams[beam]).fill(0).forEach((element) => {
                    let beamPosition = [
                        Math.trunc((group.sections[0].offset / 1000 + widthOffset) * 1000) / 1000,
                        0,
                        0,
                    ];
                    const xBeamPosition = beamPosition[0];
                    let beamSectionId = "";
                    group.sections.forEach((section, i, arr) => {
                        if (
                            section.offset <= xBeamPosition * 1000 ||
                            (section.offset < xBeamPosition * 1000 &&
                                section.offset + section.width > xBeamPosition * 1000)
                        ) {
                            beamSectionId = section.id;
                        }
                    });

                    beams.push({
                        position: beamPosition,
                        width: Number(beam),
                        model: models[`${beam}`] ?? "",
                        modelId: modelIds[`${beam}`] ?? "",
                        sectionId: beamSectionId,
                    });
                    widthOffset += Number(beam) / 1000;
                });
            });
        });
    return beams;
};
